// src/pages/Recrutement.jsx
import React, { useState, useRef } from 'react';
import emailjs from 'emailjs-com';
import { Cloudinary } from 'cloudinary-core';
import './Recrutement.css';

const cl = new Cloudinary({ cloud_name: 'dvh29lca9' });

function Recrutement() {
  const [nom, setNom] = useState('');
  const [email, setEmail] = useState('');
  const [tel, setTel] = useState('');
  const [ville, setVille] = useState('');
  const [cvUrl, setCvUrl] = useState('');
  const form = useRef();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'zrs0yiez');

    const response = await fetch(`https://api.cloudinary.com/v1_1/${cl.config().cloud_name}/upload`, {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    setCvUrl(data.secure_url);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

   
    const templateParams = {
      user_name: nom,
      user_email: email,
      user_tel: tel,
      user_ville: ville,
      user_cv: cvUrl,
    };

    emailjs.send(
      'service_b8zpy4i', // SERVICE_ID
      'template_1vf30x8', // TEMPLATE_ID
      templateParams,
      'GpNBnTF5p3finGOWM' // PUBLIC_KEY
    ).then(
      () => {
        console.log('SUCCESS!');
        setNom('');
        setEmail('');
        setTel('');
        setVille('');
        setCvUrl('');
        form.current.reset();
        setShowSuccessPopup(true);
        setTimeout(() => {
          setShowSuccessPopup(false);
        }, 3000);
      },
      (error) => {
        console.log('FAILED...', error.text);
      }
    );
    emailjs.send(
      'service_b8zpy4i', // SERVICE_ID
      'template_1vf30x8', // TEMPLATE_ID
      templateParams,
      'GpNBnTF5p3finGOWM' // PUBLIC_KEY
    ).then(
      () => {
        console.log('SUCCESS!');
        setNom('');
        setEmail('');
        setTel('');
        setVille('');
        setCvUrl('');
        form.current.reset();
        setShowSuccessPopup(true);
        setTimeout(() => {
          setShowSuccessPopup(false);
        }, 3000);
      },
      (error) => {
        console.log('FAILED...', error.text);
      }
    );

  };

  return (
    <div className="recrutement-container">
      <div className='About'>
        <div className="banner">
          <div className="images-container">
            <img src="/recrut.jpg" alt="Instruments de ménage" className="banner-image" />
          </div>
          <div className="banners-content">
            <h1>Recrutement</h1>
          </div>
        </div>
        <div className="about-us-section">
          <div className="one">
            <h1>Rejoignez Notre Équipe</h1>
          </div>
        </div>
      </div>

      <div className='prec'>
        <p className='rec'>Bienvenue sur la page de recrutement. Nous recherchons des talents pour rejoindre notre équipe.</p>
      </div>

      <div className="Container">
        <div className="images-section">
          <img src="/contact.png" alt="Description" />
        </div>
        <div className="form-section">
          <h2>Postulez Maintenant !</h2>
          <form ref={form} onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="nom">Nom et Prénom</label>
              <input
                type="text"
                id="nom"
                name="user_name"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="user_email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="tel">Numéro de téléphone</label>
              <input
                type="tel"
                id="tel"
                name="user_tel"
                value={tel}
                onChange={(e) => setTel(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="ville">Ville</label>
              <select
            id="ville"
            name="user_ville"
            value={ville}
            onChange={(e) => setVille(e.target.value)}
            required
          >
            <option value="Agadir">Agadir</option>
            <option value="Marrakech">Marrakech</option>
            <option value="Casablanca">Casablanca</option>
          </select>
            </div>
            <div className="form-group">
              <label htmlFor="cv">Télécharger votre CV</label>
              <input
                type="file"
                id="cv"
                onChange={handleFileUpload}
                required
              />
              {cvUrl && (
                <p>Fichier téléchargé: <a href={cvUrl} target="_blank" rel="noopener noreferrer">Voir le CV</a></p>
              )}
            </div>
            <button type="submit">Envoyer</button>
          </form>
          {showSuccessPopup && (
            <div
              style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'green',
                color: 'white',
                padding: '20px',
                borderRadius: '5px',
                zIndex: '9999',
              }}
            >
              Message envoyé !
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Recrutement;
